<template>
    <div class="checkout-radio">
        <input
            :id="`shippingMethod-${method.id}`"
            v-model="model"
            type="radio"
            class="sr-only"
            name="shippingMethodHandle"
            :value="method.handle"
            required
        >

        <label :for="`shippingMethod-${method.id}`" class="flex items-center p-2 bg-secondary-100 mb-2">
            <span class="checkout-radio__radio"></span>

            <span class="flex flex-1 items-center justify-between pr-4 text-sm">
                <span class="flex-1">
                    <span>{{ method.name }}</span>
                    <span v-if="method.description" class="block text-xs text-gray-800">{{ method.description }}</span>
                </span>

                <span class="font-bold">{{ method.price }}</span>
            </span>
        </label>
    </div>
</template>

<script setup>
const { method } = defineProps({
    method: {
        type: Object,
        required: true,
    },
});

const model = defineModel({
    type: String,
    default: '',
});
</script>
